/**
 * @fileoverview AgentShield Express Middleware
 * @version 0.1.0
 * @license MIT OR Apache-2.0
 */

export * from './middleware';
export * from './types';
export * from './session-helper';

// Export enhanced middleware with built-in features
export { 
  createEnhancedAgentShieldMiddleware,
  type EnhancedMiddlewareConfig,
  type StorageAdapter,
  type StorageConfig,
  type AgentDetectionEvent,
  type AgentSession,
} from './enhanced-middleware';

// Export storage adapters for advanced users
export { 
  MemoryStorageAdapter,
  RedisStorageAdapter,
  createStorageAdapter,
} from './storage';

/**
 * Library version
 */
export const VERSION = '0.1.0';
